import styled from '@emotion/styled';
import {
  LaptopPoint,
  ContainerBreakPoint,
  iPadBreakPoint,
  mobileBreakPoint,
} from 'src/utils/ResponsiveDesign';

const Container = styled.div({
  position: 'relative',
  maxWidth: 1500,
  margin: '80px auto',
  [LaptopPoint]: {
    margin: '40px auto',
    maxWidth: 1200,
  },
  [ContainerBreakPoint]: {
    maxWidth: 800,
  },
  [iPadBreakPoint]: {
    maxWidth: 700,
  },
  [mobileBreakPoint]: {
    maxWidth: 400,
  },
});

export default Container;
